const defaultSettings = {
    formWidth : 600,
    formGap : 8,
    tabName: "info",
    lang: "en",
    languages: ["en", "bg"],
    mainLanguages: ["en", "bg"],
    "maxDiffBetweenRequestAndCharge": 1.2,
}

export default defaultSettings;
